import AddressOption from '@components/order/models/edit/AddressOption';
import { ButtonBase } from '@mui/material';
import { grey } from '@mui/material/colors';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface AddressOptionBaseButtonProps {
    value: AddressOption;
    selectedValue: AddressOption;
    onClick: (addressOption: AddressOption) => void;
    children: React.ReactNode;
    disabled?: boolean;
}

const AddressOptionBaseButton: React.FC<AddressOptionBaseButtonProps> = observer(({ value, selectedValue, onClick, children, disabled = false }) => {
    var isSelected = value === selectedValue;
    return (
        <ButtonBase
            onClick={() => onClick(value)}
            disabled={disabled}
            sx={(theme) => ({
                boxShadow: isSelected ? theme.shadows[11] : theme.shadows[1],
                // backgroundColor: isSelected ? theme.palette.secondary.main : "background.default",
                p: 1.5,
                pt: 1.1,
                pb: 1.1,
                width: "100%",
                justifyContent: "flex-start",
                position: "relative",
                borderRadius: 0.6,
                ":hover": {
                    boxShadow: isSelected ? theme.shadows[11] : theme.shadows[2],
                },
                ":disabled": {
                    backgroundColor: grey[300]
                }
            })}>
            {children}
        </ButtonBase>
    )
})

export default AddressOptionBaseButton;